<template>
  <div class="regist">
    <form method="post" action="/register">
      <input type="hidden" name="member_type" :value="data.memberType" />
      <template v-if="data.hopePrefectures.length > 0">
        <template v-for="(prefecture, i) in data.hopePrefectures" :key="i">
          <input type="hidden" name="hope_prefectures[]" :value="prefecture" />
        </template>
      </template>
      <input
        v-if="data.hopePrefectures.length === 0"
        type="hidden"
        name="hope_prefectures[]"
        value=""
      />

      <template v-if="data.hopeKeywords.length > 0">
        <template v-for="(keyword, j) in data.hopeKeywords" :key="j">
          <input type="hidden" name="hope_keywords[]" :value="keyword" />
        </template>
      </template>
      <input
        v-if="data.hopeKeywords.length === 0"
        type="hidden"
        name="hope_keywords[]"
        value=""
      />

      <input type="hidden" name="name_sei" :value="data.userProfile.name_sei" />
      <input type="hidden" name="name_mei" :value="data.userProfile.name_mei" />
      <input type="hidden" name="kana_sei" :value="data.userProfile.kana_sei" />
      <input type="hidden" name="kana_mei" :value="data.userProfile.kana_mei" />
      <input type="hidden" name="gender" :value="data.userProfile.gender" />
      <input type="hidden" name="birthday" :value="data.userProfile.birthday" />
      <input type="hidden" name="email" :value="data.userProfile.email" />
      <input
        type="hidden"
        name="email_confirmation"
        :value="data.userProfile.email_confirmation"
      />
      <input type="hidden" name="zip" :value="data.userProfile.zip" />
      <input
        type="hidden"
        name="prefecture"
        :value="data.userProfile.prefecture"
      />
      <input type="hidden" name="city" :value="data.userProfile.city" />
      <input type="hidden" name="town" :value="data.userProfile.town" />
      <input type="hidden" name="tel" :value="data.userProfile.tel" />
      <input type="hidden" name="password" :value="data.userProfile.password" />

      <input
        type="hidden"
        name="socialplus_id"
        :value="data.userProfile.socialplus_id"
      />

      <input
        type="hidden"
        name="password_confirmation"
        :value="data.userProfile.password_confirmation"
      />

      <template v-if="data.userProfile.isEqualHolidayAddress">
        <input
          type="hidden"
          name="zip_vacation"
          :value="data.userProfile.zip"
        />
        <input
          type="hidden"
          name="prefecture_vacation"
          :value="data.userProfile.prefecture"
        />
        <input
          type="hidden"
          name="city_vacation"
          :value="data.userProfile.city"
        />
        <input
          type="hidden"
          name="town_vacation"
          :value="data.userProfile.town"
        />
      </template>

      <input
        type="hidden"
        name="vacation_flg"
        :value="data.userProfile.isEqualHolidayAddress"
      />

      <template v-if="!data.userProfile.isEqualHolidayAddress">
        <input
          type="hidden"
          name="zip_vacation"
          :value="data.userProfile.zip_vacation"
        />
        <input
          type="hidden"
          name="prefecture_vacation"
          :value="data.userProfile.prefecture_vacation"
        />
        <input
          type="hidden"
          name="city_vacation"
          :value="data.userProfile.city_vacation"
        />
        <input
          type="hidden"
          name="town_vacation"
          :value="data.userProfile.town_vacation"
        />
      </template>

      <input
        type="hidden"
        name="school_id"
        :value="data.userProfile.school_id"
      />

      <input
        type="hidden"
        name="graduate_year"
        :value="data.userProfile.graduate_year"
      />

      <template v-if="data.memberType === '2'">
        <input
          type="hidden"
          name="licensing_year"
          :value="data.userProfile.licensing_year"
        />
        <input
          type="hidden"
          name="work_place"
          :value="data.userProfile.work_place"
        />
        <input
          v-if="data.userProfile.hoped_departments[0]"
          type="hidden"
          name="hoped_departments[]"
          :value="data.userProfile.hoped_departments[0]"
        />
        <input
          v-if="data.userProfile.hoped_departments[1]"
          type="hidden"
          name="hoped_departments[]"
          :value="data.userProfile.hoped_departments[1]"
        />
        <input
          v-if="data.userProfile.hoped_departments[2]"
          type="hidden"
          name="hoped_departments[]"
          :value="data.userProfile.hoped_departments[2]"
        />
      </template>

      <input type="hidden" name="q" :value="data.query" />
      <input type="hidden" name="invitationCode" :value="data.invitationCode" />
      <input type="hidden" name="_token" :value="csrf" />

      <section class="preview">
        <HeadingLv4 text="入力情報" />
        <PreviewPairData
          v-for="(item, i) in confirmContents"
          :key="i"
          :label="item.label"
          :content="item.content"
        />
      </section>

      <section>
        <HeadingLv4 text="マイナビRESIDENT 利用規約" label="req" />
        <TextBlock class="textFooter">
          <p class="textCenter">
            <button type="button" class="btn" @click="openTermsModal">
              利⽤規約はこちら
            </button>
          </p>
        </TextBlock>
        <ModalTerms v-if="termsModal.isShow" :closeModal="closeTermsModal" />

        <CheckboxButton
          id="confirmCheck03"
          name="agree_flg"
          label="上記の利用規約に同意する"
          value="1"
          :checked="flgState.agree_flg"
          @call-input-change="changeFlg('agree_flg', $event)"
          block
        />

        <HrBlock />

        <CheckboxButton
          id="confirmCheck01"
          name="main_email_flg"
          label="マイナビRESIDENTの配信メールを<br>希望する"
          value="1"
          :checked="flgState.mail_magzine_flg"
          @call-input-change="changeFlg('mail_magzine_flg', $event)"
          block
        />
      </section>

      <HrBlock />

      <section class="hipokura">
        <HpcrRegister
          :noIframe="true"
          :isRegisterByLine="!!data.userProfile.socialplus_id"
        />
        <CheckboxButton
          id="confirmCheck02"
          name="hpcr_regist_status"
          label="上記の利用規約、プライバシーポリシーに同意してヒポクラに同時登録する"
          value="1"
          :checked="flgState.hpcr_regist_flg"
          @call-input-change="changeFlg('hpcr_regist_flg', $event)"
          block
        />
      </section>

      <HrBlock />

      <section>
        <DoctorRegister />
        <CheckboxButton
          id="confirmCheck04"
          name="doctor_regist_flg"
          label="上記の利用規約、プライバシーポリシーに同意してマイナビDOCTORに同時登録する"
          value="1"
          :checked="flgState.doctor_regist_flg"
          @call-input-change="changeFlg('doctor_regist_flg', $event)"
          block
        />
      </section>

      <GoalButtons>
        <Button label="戻る" :handleClick="goBack" />
        <Button
          label="登録を完了する"
          primary
          :handleClick="register"
          :disabled="isDisabledNextBtn"
        />
      </GoalButtons>
    </form>
  </div>
</template>

<script lang="ts">
import { onMounted, computed, reactive, ref, defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import HpcrRegister from '@/components/block/HpcrRegister.vue'
import DoctorRegister from '@/components/block/DoctorRegister.vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import ModalTerms from '@/components/block/ModalTerms.vue'

export default defineComponent({
  name: 'RegistConfirm',

  components: {
    PreviewPairData,
    GoalButtons,
    HpcrRegister,
    DoctorRegister,
    HeadingLv4,
    CheckboxButton,
    Button,
    HrBlock,
    TextBlock,
    ModalTerms
  },

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context) {
    const termsModal = reactive({
      isShow: false
    })
    const closeTermsModal = () => (termsModal.isShow = false)
    const openTermsModal = () => (termsModal.isShow = true)

    const store = useStore()
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    const selectedMemberType = store.state.master.memberType.filter(
      (option: any) => option.opt_id === props.data.memberType
    )

    const selectedArea: Array<string> = []
    store.state.master.prefectures.map((option: any) => {
      if (props.data.hopePrefectures.includes(option.opt_id))
        selectedArea.push(option.option_name)
    })

    const selectedKeywords: Array<string> = []
    store.state.master.keywords.map((option: any) => {
      if (props.data.hopeKeywords.includes(option.opt_id))
        selectedKeywords.push(option.option_name)
    })

    const selectedGender = store.state.master.gender.filter(
      (option: any) => option.opt_id === props.data.userProfile.gender
    )
    const birthdayArray = props.data.userProfile.birthday.split('/')
    const setZip = (value: string) => {
      if (!value) return ''
      return value.substr(0, 3) + '-' + value.substr(-4)
    }

    const selectedPrefecture = store.state.master.prefectures.filter(
      (option: any) => option.opt_id === props.data.userProfile.prefecture
    )
    const prefectureName =
      selectedPrefecture.length > 0 ? selectedPrefecture[0].option_name : ''

    let address = setZip(props.data.userProfile.zip)
      ? `${setZip(props.data.userProfile.zip)}<br>`
      : ''

    address += `${prefectureName}${props.data.userProfile.city}${props.data.userProfile.town}`

    let vacationAddress = ''
    if (props.data.userProfile.isEqualHolidayAddress) {
      vacationAddress = address
    } else {
      const selectedPrefectureVacation = store.state.master.prefectures.filter(
        (option: any) =>
          option.opt_id === props.data.userProfile.prefecture_vacation
      )
      const prefectureVacationName =
        selectedPrefectureVacation.length > 0
          ? selectedPrefectureVacation[0].option_name
          : ''

      vacationAddress = setZip(props.data.userProfile.zip_vacation)
        ? `${setZip(props.data.userProfile.zip_vacation)}<br>`
        : ''
      vacationAddress += `${prefectureVacationName}${props.data.userProfile.city_vacation}${props.data.userProfile.town_vacation}`
    }

    const selectedSchool = store.state.master.university.filter(
      (option: any) => option.opt_id === props.data.userProfile.school_id
    )

    const hiddenPassword = () => {
      let res = ''
      for (let i = 0; i < props.data.userProfile.password.length; i++) {
        res += '●'
      }
      return res
    }

    const confirmContents = [
      {
        label: '現在の職種',
        content: selectedMemberType[0].option_name
      },
      {
        label: '希望エリア',
        content: selectedArea.join(',')
      },
      {
        label: 'こだわり条件',
        content: selectedKeywords.join(',')
      },

      {
        label: '姓名（漢字）',
        content: `${props.data.userProfile.name_sei} ${props.data.userProfile.name_mei}`
      },
      {
        label: '姓名（カナ）',
        content: `${props.data.userProfile.kana_sei} ${props.data.userProfile.kana_mei}`
      },
      {
        label: '性別',
        content: selectedGender[0].option_name
      },
      {
        label: '生年月日',
        content: `${birthdayArray[0]}年${birthdayArray[1]}月${birthdayArray[2]}日`
      },
      {
        label: 'メールアドレス',
        content: props.data.userProfile.email
      },
      {
        label: '住所',
        content: address
      },
      {
        label: '電話番号',
        content: props.data.userProfile.tel
      },
      {
        label: '休暇中住所',
        content: vacationAddress
      },
      {
        label: '大学名',
        content: selectedSchool[0].option_name
      },
      {
        label: '卒業時期（年）',
        content: `${props.data.userProfile.graduate_year}年`
      }
    ]

    if (props.data.memberType === '2') {
      confirmContents.push({
        label: '医師免許取得年',
        content: `${props.data.userProfile.licensing_year}年`
      })
      confirmContents.push({
        label: '現勤務先',
        content: `${props.data.userProfile.work_place}`
      })

      const selectedDepartments: any = []

      for (
        let i = 0;
        i < props.data.userProfile.hoped_departments.length;
        i++
      ) {
        if (props.data.userProfile.hoped_departments[i] === '') continue

        const selected = store.state.master.departments.filter(
          (option: any) =>
            option.opt_id === props.data.userProfile.hoped_departments[i]
        )
        selectedDepartments.push(selected[0].option_name)
      }

      confirmContents.push({
        label: '希望科目',
        content: selectedDepartments.join(',')
      })
    }

    confirmContents.push({
      label: 'パスワード',
      content: hiddenPassword()
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )
    const register = () => {
      store.commit('showLoading')
      document.querySelector('form')!.submit()
    }

    interface StateObject {
      [key: string]: boolean
    }

    const flgState: StateObject = reactive({
      agree_flg: false,
      mail_magzine_flg: true,
      hpcr_regist_flg: true,
      doctor_regist_flg: true
    })

    const changeFlg = (target: string, ev: any) => {
      flgState[target] = ev.checked
    }

    const isDisabledNextBtn = computed(() => {
      return flgState.agree_flg ? false : true
    })

    const goBack = () => {
      router.push('/register/profile')
    }

    onMounted(() => {
      context.emit('update-flow', 4)
    })

    return {
      confirmContents,
      csrf,
      flgState,
      changeFlg,
      isDisabledNextBtn,
      register,
      goBack,
      termsModal,
      closeTermsModal,
      openTermsModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.preview {
  margin-bottom: 20px;
}

.hipokura {
  margin-top: -30px;
}
.btn {
  text-align: center;
  color: var.$color-main-text;
  font-size: 1.2rem;
  word-break: break-all;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  &:after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid #29ccc3;
    border-bottom: 2px solid #29ccc3;
    transform: rotate(-45deg) translateY(-1px);
    margin-left: 4px;
    transition: border-color 0.1s;
  }
}
.textFooter {
  margin-top: 14px;
  margin-bottom: 14px;
}
.textCenter {
  text-align: center;
}
</style>
